import { render, staticRenderFns } from "./ShadowDimming1.vue?vue&type=template&id=681f128a&scoped=true"
import script from "./ShadowDimming1.vue?vue&type=script&lang=js"
export * from "./ShadowDimming1.vue?vue&type=script&lang=js"
import style0 from "./ShadowDimming1.vue?vue&type=style&index=0&id=681f128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f128a",
  null
  
)

export default component.exports